// @ts-nocheck

class GlobalPreloaderHelper {
  preloader: HTMLElement = null;

  init() {
    this.preloader = document.getElementById('global_preloader');
  }

  private getPreloader(): HTMLElement | null {
    if (!this.preloader) {
      this.preloader = document.getElementById('global_preloader');
    }
    return this.preloader;
  }

  show() {
    this.getPreloader()?.classList.add('visible');
  }

  hide() {
    this.getPreloader()?.classList.remove('visible');
  }
}

export default new GlobalPreloaderHelper();
